import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  width: 12,
  height: 14,
  viewboxWidth: 12,
  viewboxHeight: 14,
};

// Appears unused
const FilterListSMSIcon = ({
  width = defaults.width,
  height = defaults.height,
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...props
}) => {
  return (
    <SVGLoader
      {...props}
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fillRule="evenodd">
        <g
          id="filter-04"
          transform="translate(-21.000000, -260.000000)"
          fillRule="nonzero"
        >
          <path
            d="M33.6,260 L21.84,260 C21.3760808,260 21,260.376081 21,260.84 L21,267.84 C21,268.303919 21.3760808,268.68 21.84,268.68 L26.1184,268.68 L27.4764,271.06 C27.5261171,271.147727 27.6191645,271.201946 27.72,271.201946 C27.8208355,271.201946 27.9138829,271.147727 27.9636,271.06 L29.3216,268.68 L33.6,268.68 C34.0639192,268.68 34.44,268.303919 34.44,267.84 L34.44,260.84 C34.44,260.376081 34.0639192,260 33.6,260 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </SVGLoader>
  );
};

export default FilterListSMSIcon;
